// extracted by mini-css-extract-plugin
export default {"empty":"currentChatData_empty__2U2eg"};